import { BASE_API } from "../utils/constants";

export async function getSettingsApi() {

    try {
        const url = `${BASE_API}/api/settings/`;

        const response = await fetch(url);

        const result = await response.json();

        return result;

    } catch (error) {
        throw error;
    }

}

export async function newSettingApi(data, token){
    //console.log(data.image);
    //console.log(token);
    try {
        //CUADNO TRABAJAMOS CON IMAGEN INSTANCIAR FORM DATA       

        const url = `${BASE_API}/api/settings/`;

        const params = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-type": "application/json"         
            },
            //3
            body: JSON.stringify(data),            
        };
        const response = await fetch(url, params);

        const result = await response.json();

        return result

    } catch (error) {
        throw error
    }
}

export async function editSettingApi(id, data, token)  {

    try {
        
        const url = `${BASE_API}/api/settings/${id}/`;
        const params = {
            method: 'PATCH',
            headers: {
                Authorization: `Bearer ${token}`, 
                "Content-type": "application/json"            
            },
            body: JSON.stringify(data) 
        }

        const response = await fetch(url, params);
        const result = await response.json();

        return result;

    } catch (error) {
        throw error;
    }


}


export async function deleteSettingApi(id, token)  {
    try {
        const url = `${BASE_API}/api/settings/${id}/`;
        const params = {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`             
            }
        }
        const response = await fetch(url, params);
        const result = await response.json();
        return result;
        
    } catch (error) {
        throw error;
    }
}